<template>
  <div>
    <div class="descWrap">
      <div class="topTitle">公告中心</div>
      <div class="infoWrap">
        <el-row>
          <el-col :span="5" class="noticeTlt">
            <div>
              <span
                @click="gotoNotice"
              >返回</span>
            </div>
          </el-col>
          <el-col :span="18" :offset="1">
            <el-col :span="24">
              <div class="noticeTitle">
                {{ title }}
              </div>
            </el-col>
            <div style="padding-top:30px">
              <div class="cardContent" v-html="content" />
            </div>
            <div style="text-align:center">
              <img :src="imgUrl" alt="" style="width:90%;height:auto;">
            </div>
            <el-col :span="24" class="timeWrap">
              <!-- <img v-show="time" src="../../../assets/images/noticeLogo.png" style="height:45px"> -->
              <span>{{ time }}</span>
            </el-col>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocol*/
export default {
  name: 'NoticeDetail',
  data() {
    return {
      currentclassifyId: 2,
      isCurrentId: this.$route.params.articleId,
      content: '',
      sign: '',
      title: '',
      time: '',
      imgUrl: '',

      ismore: '查看更多',
      selectnPage: window.sessionStorage.getItem('selectnPage'),
      param_getArticle: {}
    }
  },
  computed: {},
  watch: {},
  mounted() {
    // const currentTab = window.sessionStorage.getItem('selectnPage')
    this.getArticle(this.isCurrentId)
  },
  methods: {
    gotoNotice() {
      this.$router.push('/myNotice/notice/noticelist')
    },

    getArticle(id) {
      const that = this
      // const localeLanguage = localStorage.lang || navigator.language.slice(-2).toLowerCase()
      this.param_getArticle = protocol.param_getContentDetails
      this.param_getArticle.param.id = id
      http.getRes(this.param_getArticle).then(response => {
        const { code, message, value } = response.data
        if (code == '0') {
          that.imgUrl = value.titleImg
          that.title = value.title
          that.content = value.content
          that.time = global.util.dateFormate(Number(value.createTime))
        } else {
          this.$message(message)
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.descWrap {
  width: 100%;
  margin: 0 auto;
  background-color: #ffffff;
  min-height: calc(100vh - 50px);
  .infoWrap{
    width: 80%;
    margin: 0 auto;
    padding-top: 60px;
    .el-row{
      text-align: left;
      margin: 0;
    }
  }
}
.noticeTitle{
  font-weight: 600;
  color: rgba($color: #fff, $alpha: 0.8);
  font-size: 26px;
  padding-bottom: 30px;
}
.timeWrap{
  text-align: right;
  font-size: 20px;
  font-weight: 600;
  padding-top: 100px;
  span{
    color: #fff;
  }
}
.topTitle {
  height: 100px;
  line-height: 100px;
  background-color: #262941;
  font-weight: 500;
  color: #ffffff;
  font-size: 30px;
  text-align: center;
}
.noticeTlt {
  cursor: pointer;
  height: 65px;
  background-color: transparent;
  line-height: 65px;
  font-family: 'MicrosoftYaHei', '微软雅黑';
  font-weight: 200;
  color: #2483FF;
  font-size: 29px;
  padding-left: 20px;
  span{
    border: 2px solid #2483FF;
    border-radius: 4px;
    padding: 6px 10px;
  }
}
.noticeTlt /deep/ .el-input__inner {
  background-color: transparent;
  height: 30px;
  border-radius: 15px;
  font-size: 14px;
  overflow: hidden;
  // border: 1px solid rgba(64,144,253,1);
  border: none;
  background: #263562;
  color: #fff;
}
.noticeTlt /deep/ .el-input__inner::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #fff;
  font-size: 14px;
}

.noticeTlt /deep/ .el-input__inner::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #fff;
  font-size: 14px;
}

.noticeTlt /deep/ .el-input__inner:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #fff;
  font-size: 14px;
}
.currentId {
  color: #2483ff;
}
.titleClass {
  line-height: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  cursor: pointer;
}
.more {
  color: #5f82f9;
  cursor: pointer;
  margin-top: 10px;
}
.cardContent {
  /deep/ p {
    color: #fff;
    margin: 10px 0 !important;
    font-size: 18px;
  }
}
</style>
